module.exports = __webpack_public_path__ + "img/symbol_1.b21a1a82.png";